import React, { useEffect } from 'react';
import { MdEmail } from 'react-icons/md'
import { IoLogoWhatsapp } from 'react-icons/io'
import { useRef } from 'react';
import emailjs from 'emailjs-com'
import Footer from '../footer/Footer'


import avatarContact from '../../assets/img/avatar-msg.png'

import AOS from 'aos'
import 'aos/dist/aos.css';

import './contact.css'


const Contact = () => {
  const form = useRef();
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_oxh3sdw', 'template_vs5iilp', form.current, 'vUaMvyGeQyB_t_9FQ')
      .then((result) => {
          console.log(result.text);
      }, (error) => {
          console.log(error.text);
      });
    e.target.reset()
  };

  useEffect(() => {
    AOS.init({duration: 800})
  }, []);
  return (
    <section id='contact'>
      <h4 data-aos="fade-up" data-aos-anchor-placement="top-bottom" data-aos-delay="100">Get In Touch</h4>
      <h2 data-aos="fade-up" data-aos-anchor-placement="top-bottom" data-aos-delay="200">Contact Me</h2>
      <div className="container contact-container">
        <div className="msg-avatar" data-aos="fade-right" data-aos-delay="700">
          <img src={avatarContact} alt="Send Message" />
        </div>

        <form ref={form} onSubmit={sendEmail} >
          <div className="formulary" data-aos="fade-right" data-aos-delay="400">
            <input type="text" name='name' placeholder='Your Full Name' required />
            <input type="email" name='email' placeholder='Your Email' required />
            <textarea name="message" rows="5" placeholder='Your Message' required></textarea>
          </div>
          <div className="btn-content">
            <button type='submit' className='btn btn-primary' data-aos="fade-right" data-aos-delay="600">Send Message</button>
            <div className="contact-options">
              <a href="mailto:remane.mussagy@gmail.com" className='contact-option' data-aos="fade-right" data-aos-delay="500">
                <MdEmail className='contact-icon'/> <span>remane.mussagy@gmail.com</span>
              </a>
              <a href="https://api.whatsapp.com//send?phone=+258845938571" target='_blank' rel="noopener noreferrer" className='contact-option' data-aos="fade-right" data-aos-delay="400">
                <IoLogoWhatsapp className='contact-icon'/> <span>+258-845938571</span>
              </a>
            </div>
          </div>
        </form>
      </div>
      <div className="footer">
        <Footer/>
      </div>
    </section>
  );
}

export default Contact;
